module.exports = __webpack_public_path__ + "26dfc3bd5790f426e09a23ea67a948b9.svg";